import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { VgUtils, VgAPI, VgMedia } from 'app/_modules/player/core';
import { IMedia } from '../video/videoplayer/videoplayer.imedia';
import { videoPlayerApi } from '../video/videoplayer/videoplayer.api';
import { playerUtil } from '../video/videoplayer/videoplayer.utils';
import { videoPlayerVgApi } from '../video/videoplayer/videoplayer.vgApi';
import {  PlayerTech } from '../video/videoplayer/videoplayer.config';
import { environment } from 'environments/environment';
import { Utility } from 'app/_service/utility';

@Component({
  selector: 'app-simple-videoplayer',
  templateUrl: './simple-videoplayer.component.html',
  styleUrls: ['../video/videoplayer/videoplayer.component.scss', './simple-videoplayer.component.scss']
})
export class SimpleVideoplayerComponent implements OnInit, OnDestroy {
  public isPlayerReady = false;
  public isControlshow = true;
  public currentPlayingLevel = 0;
  public media: IMedia = null;
  public playerSelection: PlayerTech = PlayerTech.Original; // 播放器的选择
  public shouldPlaySeoncd = 0;
  public mutable = false; //为真时，用户只使用H5播放器
  public isVideoSuccessPlayed = false;
  public videoSuccessPlayerTimeout = null;

  api: videoPlayerApi;
  isIPhone = false;
  volume = 0; // 默认静音
  isPaused = false;
  hasError = false;
  errorContent = '';
  needUserTouch = false;
  autoHide = true;
  errorText = "发生了未知错误，点击切换模式";
  videoStyle = {};
  isMasterEnabled = false; // 是否解析成功
  currentLevel: any = {};
  currentBitrate = null;
  playSuccess = false;

  private subscriptions = [];
  private _bitrates = [];
  get bitrates() {
    return this._bitrates;
  }

  // @Input() playerWidth;
  // @Input() playerHeight;

  @Input() user;
  @Input() video: any;
  ///播放列表
  @Input() set mediaList(value: Array<IMedia>) {
    this.initMedia(value);
  };
  @Input() set bitrates(value: Array<any>) {
    this._bitrates = value;
    this.currentBitrate = null;
    //  console.log(this.bitrates)
  };
  @Input() playingMedia;
  @Input() playerMode = 'auto';
  @Input() mediaTitle = '';
  @Input() poster = '';
  @Input() previewFormat = '';

  @Output() apiReady = new EventEmitter<any>();
  @Output() onVideoReady = new EventEmitter<videoPlayerApi>(); // 视频加载时
  @Output() onErrorHandler = new EventEmitter<boolean>(); // 视频加载时
  @Output() onPlay = new EventEmitter();
  @Output() onEnd = new EventEmitter();

  constructor(
    private _utility: Utility,
  ) { }

  ngOnInit(): void {
    this.isPlayerReady = true;
    this.playerSelection = PlayerTech.Original;
    this.mutable = true;
    VgUtils.shouldUseNative = true;
    VgUtils.shouldHandleMouse = !playerUtil.isIphoneDevice();
    VgUtils.shouldUseFakeFullScreen = false;
    VgUtils.useFakeFullScreenWhenNotPossible = true;
    this.isIPhone = playerUtil.isIphoneDevice();
    if (environment.app) {
      this.mutable = true;
    }
  }

  ngOnDestroy(): void {
   // console.log("video should destroyed")
    this.dispose();
    this.subscriptions.forEach(p => !!p["unsubscribe"] ? p.unsubscribe() : p())
  }

  public initMedia(mediaList: Array<IMedia>) {
    if (!!mediaList) {
      // this.mediaList = mediaList;
      this.media = mediaList.find(p => !!p && !p.isAd);
    }
  }

  private dispose() {
    this.api.dispose();
    this.api = null;
  }

  /* 播放器加载完成 */
  onPlayerReady(api: VgAPI) {
    // console.log("simple player ready");
    this.api = new videoPlayerVgApi();
    this.apiReady.emit(this.api);
    this.api["assignData"](api, <Component>this);
    this.api['canViewPublic'] = this._utility.canViewPublic;
    this.subscriptions.push((<VgMedia>api.getDefaultMedia()).subscriptions.volumeChange.subscribe((val) => {
      // this.volume = this.api.getVolume();
      this.volume = 0; // 默认静音
    }));

    this.subscriptions.push((<VgMedia>api.getDefaultMedia())
      .subscriptions
      .loadedMetadata
      .subscribe(
        () => {
          this.needPlayVideo(); // 自动播放
          // this.videoSuccessPlayerTimeout = VgUtils.setTimeout(() => {
          //   if (playerUtil.isQQBrwoser() && playerUtil.isIphoneDevice()) {
          //     this.needUserTouch = false;
          //     this.isVideoSuccessPlayed = true;
          //   }
          //   else {
          //     if (!this.isVideoSuccessPlayed) {
          //       this.needUserTouch = true;
          //       api.triggerUserTouch();
          //     }
          //   }
          // }, 200);
        }
      ));

    this.subscriptions.push((<VgMedia>api.getDefaultMedia()).subscriptions.play.subscribe(() => {
      this.needUserTouch = false;
      this.isVideoSuccessPlayed = true;
      VgUtils.clearTimeout(this.videoSuccessPlayerTimeout);
    }));

    this._onPlayerReady();
    this.onVideoReady.emit(this.api);
  }

  /* 需要播放视频 */
  private needPlayVideo() {
    this.api.setVolume(this.volume * 100);
    if (!!this.media && this.media.isHls) {
      this.api.seek(this.shouldPlaySeoncd || 0);
      this.shouldPlaySeoncd = 0;
    }
    if (this.shouldPlaySeoncd) {
      this.api.seek(this.shouldPlaySeoncd);
      this.shouldPlaySeoncd = 0;
    }
    this.api.play();
  }

  toPlay() {
    //console.log("aaa",this.api);
    if (this.api != null) {
      //console.log("you must play");
      try {
        this.api.play();
        this.api.play(); /// the second is must
      }
      catch (ex) {
      }
    }
    this.hasError = false;
  }

  retry() {
    //console.log("error occur,")
    this.shouldPlaySeoncd = this.api.currentTime + 5;
    this.hasError = false;
    this.api.dispose();
    this.onErrorHandler.emit(true);
  }

  private _onPlayerReady() {
    this.listenToIntersitial();
  }

  private listenToIntersitial() {
    this.api.subscript("play", () => {
      this.isPaused = false;
      this.hasError = false;
      this.errorContent = "";
      this.playSuccess = true;
      this.onPlay.emit();
    });

    this.api.subscript("pause", () => {
      this.isPaused = true;
    });

    this.api.subscript("controlBarShow", (isshow) => {
      if (isshow) {
        this.isControlshow = true;
      }
      else {
        this.isControlshow = false;
      }
    });

    this.api.subscript("loadedmetadata", () => {
    });

    this.api.subscript("ended", () => {
      this.onEnd.emit(); // 播放结束关闭
    });
  }

  errorHandler(event) {
    var errorCode = 0;
    if (event && event.target && event.target.error) {
      errorCode = event.target.error.code;
    }
    switch (errorCode) {
      case 3:
        this.retry();
        break;
      default:
        this.errorContent = "未知错误，请联系客服";
        this.hasError = true;
        break;
    }
  }

  hlsErrorHandler(event) {
    this.errorContent = "网络错误，当前视频无法播放";
    this.hasError = true;
  }

  /* 以下可以忽略 */
  /* master playlist 解析成功，确定码率 */
  onMasterPlayParsed(parsed: { levels: Array<any>, startLevel: any }) {

    if (parsed.levels.length > 1) /// 多比特率，有作用
    {
      this.isMasterEnabled = true;

      for (var i = 0; i < parsed.levels.length; ++i) {
        let index = this.bitrates.findIndex(p => p.title == parsed.levels[i].label);
        if (index > -1)
          this.bitrates[index].qualityIndex = parsed.levels[i].qualityIndex;
      }

      var index = this.bitrates.findIndex(p => p.label === parsed.startLevel.label);
      this.playingMedia = this.bitrates[index];
      this.currentLevel = {};
      this.currentPlayingLevel = index;

    }
    else {
      this.isMasterEnabled = false;
    }
  }
  /* hls，自动更换 */
  onLevelChanged(data) {
    if (this.playingMedia?.qualityIndex == -1) /// 自动中
    {
      this.currentPlayingLevel = data.level;
    }
  }

}
